/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateDocumentFolderRequest,
  CreateDocumentFolderTemplateRequest,
  CreateDocumentRequest,
  DeleteChatConversation200Response,
  Document,
  DocumentDetailed,
  DocumentFolder,
  DocumentFolderTemplate,
  DocumentStatsResponse,
  ExtractDocument202Response,
  ExtractMetadataResponse,
  ExtractedDataResponse,
  GetExtractionStatus200Response,
  ListDocumentFolderTemplatesResponse,
  ListDocumentFoldersResponse,
  ListDocumentsResponse,
  MoveDocumentToFolderRequest,
  Problem,
  UpdateDocumentFolderRequest,
  UpdateDocumentFolderTemplateRequest,
  UpdateDocumentRequest,
  UpdateParseStatusRequest,
} from '../models/index';
import {
    CreateDocumentFolderRequestFromJSON,
    CreateDocumentFolderRequestToJSON,
    CreateDocumentFolderTemplateRequestFromJSON,
    CreateDocumentFolderTemplateRequestToJSON,
    CreateDocumentRequestFromJSON,
    CreateDocumentRequestToJSON,
    DeleteChatConversation200ResponseFromJSON,
    DeleteChatConversation200ResponseToJSON,
    DocumentFromJSON,
    DocumentToJSON,
    DocumentDetailedFromJSON,
    DocumentDetailedToJSON,
    DocumentFolderFromJSON,
    DocumentFolderToJSON,
    DocumentFolderTemplateFromJSON,
    DocumentFolderTemplateToJSON,
    DocumentStatsResponseFromJSON,
    DocumentStatsResponseToJSON,
    ExtractDocument202ResponseFromJSON,
    ExtractDocument202ResponseToJSON,
    ExtractMetadataResponseFromJSON,
    ExtractMetadataResponseToJSON,
    ExtractedDataResponseFromJSON,
    ExtractedDataResponseToJSON,
    GetExtractionStatus200ResponseFromJSON,
    GetExtractionStatus200ResponseToJSON,
    ListDocumentFolderTemplatesResponseFromJSON,
    ListDocumentFolderTemplatesResponseToJSON,
    ListDocumentFoldersResponseFromJSON,
    ListDocumentFoldersResponseToJSON,
    ListDocumentsResponseFromJSON,
    ListDocumentsResponseToJSON,
    MoveDocumentToFolderRequestFromJSON,
    MoveDocumentToFolderRequestToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UpdateDocumentFolderRequestFromJSON,
    UpdateDocumentFolderRequestToJSON,
    UpdateDocumentFolderTemplateRequestFromJSON,
    UpdateDocumentFolderTemplateRequestToJSON,
    UpdateDocumentRequestFromJSON,
    UpdateDocumentRequestToJSON,
    UpdateParseStatusRequestFromJSON,
    UpdateParseStatusRequestToJSON,
} from '../models/index';

export interface CreateDocumentOperationRequest {
    createDocumentRequest: CreateDocumentRequest;
}

export interface CreateDocumentFolderOperationRequest {
    claimId: number;
    createDocumentFolderRequest: CreateDocumentFolderRequest;
}

export interface CreateDocumentFolderTemplateOperationRequest {
    createDocumentFolderTemplateRequest: CreateDocumentFolderTemplateRequest;
}

export interface DeleteDocumentRequest {
    documentId: number;
}

export interface DeleteDocumentFolderRequest {
    claimId: number;
    folderId: number;
}

export interface DeleteDocumentFolderTemplateRequest {
    templateId: number;
}

export interface ExtractDocumentRequest {
    documentId: number;
}

export interface ExtractDocumentMetadataRequest {
    documentId: number;
}

export interface GetCompanyDocumentsRequest {
    page?: number;
    limit?: number;
    search?: string;
    kind?: GetCompanyDocumentsKindEnum;
    parseStatus?: GetCompanyDocumentsParseStatusEnum;
    claimId?: number;
    sortBy?: GetCompanyDocumentsSortByEnum;
    sortOrder?: GetCompanyDocumentsSortOrderEnum;
}

export interface GetDocumentRequest {
    documentId: number;
}

export interface GetDocumentContentRequest {
    documentId: number;
}

export interface GetDocumentDetailedRequest {
    documentId: number;
}

export interface GetDocumentExtractedDataRequest {
    documentId: number;
}

export interface GetDocumentsRequest {
    page?: number;
    limit?: number;
    search?: string;
    kind?: GetDocumentsKindEnum;
    parseStatus?: GetDocumentsParseStatusEnum;
    claimId?: number;
    sortBy?: GetDocumentsSortByEnum;
    sortOrder?: GetDocumentsSortOrderEnum;
}

export interface GetExtractionStatusRequest {
    documentId: number;
}

export interface GetUserDocumentsRequest {
    page?: number;
    limit?: number;
    search?: string;
    kind?: GetUserDocumentsKindEnum;
    parseStatus?: GetUserDocumentsParseStatusEnum;
    claimId?: number;
    sortBy?: GetUserDocumentsSortByEnum;
    sortOrder?: GetUserDocumentsSortOrderEnum;
}

export interface ListDocumentFoldersRequest {
    claimId: number;
}

export interface MoveDocumentToFolderOperationRequest {
    claimId: number;
    moveDocumentToFolderRequest: MoveDocumentToFolderRequest;
}

export interface UpdateDocumentOperationRequest {
    documentId: number;
    updateDocumentRequest: UpdateDocumentRequest;
}

export interface UpdateDocumentFolderOperationRequest {
    claimId: number;
    folderId: number;
    updateDocumentFolderRequest: UpdateDocumentFolderRequest;
}

export interface UpdateDocumentFolderTemplateOperationRequest {
    templateId: number;
    updateDocumentFolderTemplateRequest: UpdateDocumentFolderTemplateRequest;
}

export interface UpdateDocumentParseStatusRequest {
    documentId: number;
    updateParseStatusRequest: UpdateParseStatusRequest;
}

/**
 * DocumentsApi - interface
 * 
 * @export
 * @interface DocumentsApiInterface
 */
export interface DocumentsApiInterface {
    /**
     * Images and videos are rejected by this endpoint. This is a breaking migration; upload media through the claim Photos API instead.
     * @summary Create a new non-media document
     * @param {CreateDocumentRequest} createDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    createDocumentRaw(requestParameters: CreateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>>;

    /**
     * Images and videos are rejected by this endpoint. This is a breaking migration; upload media through the claim Photos API instead.
     * Create a new non-media document
     */
    createDocument(requestParameters: CreateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document>;

    /**
     * 
     * @summary Create a new document folder in a claim
     * @param {number} claimId 
     * @param {CreateDocumentFolderRequest} createDocumentFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    createDocumentFolderRaw(requestParameters: CreateDocumentFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentFolder>>;

    /**
     * Create a new document folder in a claim
     */
    createDocumentFolder(requestParameters: CreateDocumentFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentFolder>;

    /**
     * 
     * @summary Create a new document folder template
     * @param {CreateDocumentFolderTemplateRequest} createDocumentFolderTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    createDocumentFolderTemplateRaw(requestParameters: CreateDocumentFolderTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentFolderTemplate>>;

    /**
     * Create a new document folder template
     */
    createDocumentFolderTemplate(requestParameters: CreateDocumentFolderTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentFolderTemplate>;

    /**
     * 
     * @summary Delete a document
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    deleteDocumentRaw(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Delete a document
     */
    deleteDocument(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * 
     * @summary Delete a document folder (documents move to root)
     * @param {number} claimId 
     * @param {number} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    deleteDocumentFolderRaw(requestParameters: DeleteDocumentFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a document folder (documents move to root)
     */
    deleteDocumentFolder(requestParameters: DeleteDocumentFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete a document folder template (cascades to children)
     * @param {number} templateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    deleteDocumentFolderTemplateRaw(requestParameters: DeleteDocumentFolderTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteChatConversation200Response>>;

    /**
     * Delete a document folder template (cascades to children)
     */
    deleteDocumentFolderTemplate(requestParameters: DeleteDocumentFolderTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteChatConversation200Response>;

    /**
     * 
     * @summary Start document extraction (AI processing)
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    extractDocumentRaw(requestParameters: ExtractDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtractDocument202Response>>;

    /**
     * Start document extraction (AI processing)
     */
    extractDocument(requestParameters: ExtractDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtractDocument202Response>;

    /**
     * Extracts only header metadata (insured name, claim number, policy, etc.) from a document using Temporal workflow. This is the first step before full extraction.
     * @summary Extract document metadata only
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    extractDocumentMetadataRaw(requestParameters: ExtractDocumentMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtractMetadataResponse>>;

    /**
     * Extracts only header metadata (insured name, claim number, policy, etc.) from a document using Temporal workflow. This is the first step before full extraction.
     * Extract document metadata only
     */
    extractDocumentMetadata(requestParameters: ExtractDocumentMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtractMetadataResponse>;

    /**
     * 
     * @summary Get document statistics for the authenticated user\'s company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getCompanyDocumentStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentStatsResponse>>;

    /**
     * Get document statistics for the authenticated user\'s company
     */
    getCompanyDocumentStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentStatsResponse>;

    /**
     * 
     * @summary Get all documents for the authenticated user\'s company
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [search] 
     * @param {'insurer' | 'contractor'} [kind] 
     * @param {'pending' | 'parsed' | 'failed'} [parseStatus] 
     * @param {number} [claimId] Filter documents by claim ID
     * @param {'filename' | 'createdAt' | 'updatedAt' | 'sizeBytes'} [sortBy] 
     * @param {'asc' | 'desc'} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getCompanyDocumentsRaw(requestParameters: GetCompanyDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentsResponse>>;

    /**
     * Get all documents for the authenticated user\'s company
     */
    getCompanyDocuments(requestParameters: GetCompanyDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentsResponse>;

    /**
     * 
     * @summary Get a document by ID
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getDocumentRaw(requestParameters: GetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentDetailed>>;

    /**
     * Get a document by ID
     */
    getDocument(requestParameters: GetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentDetailed>;

    /**
     * 
     * @summary Download document content
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getDocumentContentRaw(requestParameters: GetDocumentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * Download document content
     */
    getDocumentContent(requestParameters: GetDocumentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * 
     * @summary Get detailed document information
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getDocumentDetailedRaw(requestParameters: GetDocumentDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentDetailed>>;

    /**
     * Get detailed document information
     */
    getDocumentDetailed(requestParameters: GetDocumentDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentDetailed>;

    /**
     * 
     * @summary Get extracted data from document
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getDocumentExtractedDataRaw(requestParameters: GetDocumentExtractedDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtractedDataResponse>>;

    /**
     * Get extracted data from document
     */
    getDocumentExtractedData(requestParameters: GetDocumentExtractedDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtractedDataResponse>;

    /**
     * 
     * @summary List all documents for the authenticated user\'s company
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [search] 
     * @param {'insurer' | 'contractor'} [kind] 
     * @param {'pending' | 'parsed' | 'failed'} [parseStatus] 
     * @param {number} [claimId] Filter documents by claim ID
     * @param {'filename' | 'createdAt' | 'updatedAt' | 'sizeBytes'} [sortBy] 
     * @param {'asc' | 'desc'} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getDocumentsRaw(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentsResponse>>;

    /**
     * List all documents for the authenticated user\'s company
     */
    getDocuments(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentsResponse>;

    /**
     * 
     * @summary Get document extraction status
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getExtractionStatusRaw(requestParameters: GetExtractionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExtractionStatus200Response>>;

    /**
     * Get document extraction status
     */
    getExtractionStatus(requestParameters: GetExtractionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExtractionStatus200Response>;

    /**
     * 
     * @summary Get all documents uploaded by the authenticated user
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {string} [search] 
     * @param {'insurer' | 'contractor'} [kind] 
     * @param {'pending' | 'parsed' | 'failed'} [parseStatus] 
     * @param {number} [claimId] Filter documents by claim ID
     * @param {'filename' | 'createdAt' | 'updatedAt' | 'sizeBytes'} [sortBy] 
     * @param {'asc' | 'desc'} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    getUserDocumentsRaw(requestParameters: GetUserDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentsResponse>>;

    /**
     * Get all documents uploaded by the authenticated user
     */
    getUserDocuments(requestParameters: GetUserDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentsResponse>;

    /**
     * 
     * @summary List all document folder templates for the current company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    listDocumentFolderTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentFolderTemplatesResponse>>;

    /**
     * List all document folder templates for the current company
     */
    listDocumentFolderTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentFolderTemplatesResponse>;

    /**
     * 
     * @summary List all document folders for a claim
     * @param {number} claimId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    listDocumentFoldersRaw(requestParameters: ListDocumentFoldersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentFoldersResponse>>;

    /**
     * List all document folders for a claim
     */
    listDocumentFolders(requestParameters: ListDocumentFoldersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentFoldersResponse>;

    /**
     * 
     * @summary Move a document into a folder or back to root
     * @param {number} claimId 
     * @param {MoveDocumentToFolderRequest} moveDocumentToFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    moveDocumentToFolderRaw(requestParameters: MoveDocumentToFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteChatConversation200Response>>;

    /**
     * Move a document into a folder or back to root
     */
    moveDocumentToFolder(requestParameters: MoveDocumentToFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteChatConversation200Response>;

    /**
     * 
     * @summary Update a document
     * @param {number} documentId 
     * @param {UpdateDocumentRequest} updateDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    updateDocumentRaw(requestParameters: UpdateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>>;

    /**
     * Update a document
     */
    updateDocument(requestParameters: UpdateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document>;

    /**
     * 
     * @summary Update a document folder (rename, move, recolor)
     * @param {number} claimId 
     * @param {number} folderId 
     * @param {UpdateDocumentFolderRequest} updateDocumentFolderRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    updateDocumentFolderRaw(requestParameters: UpdateDocumentFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentFolder>>;

    /**
     * Update a document folder (rename, move, recolor)
     */
    updateDocumentFolder(requestParameters: UpdateDocumentFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentFolder>;

    /**
     * 
     * @summary Update a document folder template
     * @param {number} templateId 
     * @param {UpdateDocumentFolderTemplateRequest} updateDocumentFolderTemplateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    updateDocumentFolderTemplateRaw(requestParameters: UpdateDocumentFolderTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentFolderTemplate>>;

    /**
     * Update a document folder template
     */
    updateDocumentFolderTemplate(requestParameters: UpdateDocumentFolderTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentFolderTemplate>;

    /**
     * 
     * @summary Update document parse status
     * @param {number} documentId 
     * @param {UpdateParseStatusRequest} updateParseStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApiInterface
     */
    updateDocumentParseStatusRaw(requestParameters: UpdateDocumentParseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>>;

    /**
     * Update document parse status
     */
    updateDocumentParseStatus(requestParameters: UpdateDocumentParseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document>;

}

/**
 * 
 */
export class DocumentsApi extends runtime.BaseAPI implements DocumentsApiInterface {

    /**
     * Images and videos are rejected by this endpoint. This is a breaking migration; upload media through the claim Photos API instead.
     * Create a new non-media document
     */
    async createDocumentRaw(requestParameters: CreateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters['createDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'createDocumentRequest',
                'Required parameter "createDocumentRequest" was null or undefined when calling createDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDocumentRequestToJSON(requestParameters['createDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Images and videos are rejected by this endpoint. This is a breaking migration; upload media through the claim Photos API instead.
     * Create a new non-media document
     */
    async createDocument(requestParameters: CreateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.createDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new document folder in a claim
     */
    async createDocumentFolderRaw(requestParameters: CreateDocumentFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentFolder>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling createDocumentFolder().'
            );
        }

        if (requestParameters['createDocumentFolderRequest'] == null) {
            throw new runtime.RequiredError(
                'createDocumentFolderRequest',
                'Required parameter "createDocumentFolderRequest" was null or undefined when calling createDocumentFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/folders`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDocumentFolderRequestToJSON(requestParameters['createDocumentFolderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFolderFromJSON(jsonValue));
    }

    /**
     * Create a new document folder in a claim
     */
    async createDocumentFolder(requestParameters: CreateDocumentFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentFolder> {
        const response = await this.createDocumentFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new document folder template
     */
    async createDocumentFolderTemplateRaw(requestParameters: CreateDocumentFolderTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentFolderTemplate>> {
        if (requestParameters['createDocumentFolderTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'createDocumentFolderTemplateRequest',
                'Required parameter "createDocumentFolderTemplateRequest" was null or undefined when calling createDocumentFolderTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/document-folder-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDocumentFolderTemplateRequestToJSON(requestParameters['createDocumentFolderTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFolderTemplateFromJSON(jsonValue));
    }

    /**
     * Create a new document folder template
     */
    async createDocumentFolderTemplate(requestParameters: CreateDocumentFolderTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentFolderTemplate> {
        const response = await this.createDocumentFolderTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a document
     */
    async deleteDocumentRaw(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling deleteDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete a document
     */
    async deleteDocument(requestParameters: DeleteDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.deleteDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a document folder (documents move to root)
     */
    async deleteDocumentFolderRaw(requestParameters: DeleteDocumentFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteDocumentFolder().'
            );
        }

        if (requestParameters['folderId'] == null) {
            throw new runtime.RequiredError(
                'folderId',
                'Required parameter "folderId" was null or undefined when calling deleteDocumentFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/folders/{folderId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"folderId"}}`, encodeURIComponent(String(requestParameters['folderId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a document folder (documents move to root)
     */
    async deleteDocumentFolder(requestParameters: DeleteDocumentFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteDocumentFolderRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a document folder template (cascades to children)
     */
    async deleteDocumentFolderTemplateRaw(requestParameters: DeleteDocumentFolderTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteChatConversation200Response>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling deleteDocumentFolderTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/document-folder-templates/{templateId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters['templateId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteChatConversation200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a document folder template (cascades to children)
     */
    async deleteDocumentFolderTemplate(requestParameters: DeleteDocumentFolderTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteChatConversation200Response> {
        const response = await this.deleteDocumentFolderTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Start document extraction (AI processing)
     */
    async extractDocumentRaw(requestParameters: ExtractDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtractDocument202Response>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling extractDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}/extract-document`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExtractDocument202ResponseFromJSON(jsonValue));
    }

    /**
     * Start document extraction (AI processing)
     */
    async extractDocument(requestParameters: ExtractDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtractDocument202Response> {
        const response = await this.extractDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Extracts only header metadata (insured name, claim number, policy, etc.) from a document using Temporal workflow. This is the first step before full extraction.
     * Extract document metadata only
     */
    async extractDocumentMetadataRaw(requestParameters: ExtractDocumentMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtractMetadataResponse>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling extractDocumentMetadata().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}/extract-metadata`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExtractMetadataResponseFromJSON(jsonValue));
    }

    /**
     * Extracts only header metadata (insured name, claim number, policy, etc.) from a document using Temporal workflow. This is the first step before full extraction.
     * Extract document metadata only
     */
    async extractDocumentMetadata(requestParameters: ExtractDocumentMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtractMetadataResponse> {
        const response = await this.extractDocumentMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get document statistics for the authenticated user\'s company
     */
    async getCompanyDocumentStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentStatsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/company/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentStatsResponseFromJSON(jsonValue));
    }

    /**
     * Get document statistics for the authenticated user\'s company
     */
    async getCompanyDocumentStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentStatsResponse> {
        const response = await this.getCompanyDocumentStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all documents for the authenticated user\'s company
     */
    async getCompanyDocumentsRaw(requestParameters: GetCompanyDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['kind'] != null) {
            queryParameters['kind'] = requestParameters['kind'];
        }

        if (requestParameters['parseStatus'] != null) {
            queryParameters['parseStatus'] = requestParameters['parseStatus'];
        }

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/company`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * Get all documents for the authenticated user\'s company
     */
    async getCompanyDocuments(requestParameters: GetCompanyDocumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentsResponse> {
        const response = await this.getCompanyDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a document by ID
     */
    async getDocumentRaw(requestParameters: GetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentDetailed>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDetailedFromJSON(jsonValue));
    }

    /**
     * Get a document by ID
     */
    async getDocument(requestParameters: GetDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentDetailed> {
        const response = await this.getDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download document content
     */
    async getDocumentContentRaw(requestParameters: GetDocumentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocumentContent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}/content`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download document content
     */
    async getDocumentContent(requestParameters: GetDocumentContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDocumentContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed document information
     */
    async getDocumentDetailedRaw(requestParameters: GetDocumentDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentDetailed>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocumentDetailed().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}/detailed`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentDetailedFromJSON(jsonValue));
    }

    /**
     * Get detailed document information
     */
    async getDocumentDetailed(requestParameters: GetDocumentDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentDetailed> {
        const response = await this.getDocumentDetailedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get extracted data from document
     */
    async getDocumentExtractedDataRaw(requestParameters: GetDocumentExtractedDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExtractedDataResponse>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocumentExtractedData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}/extracted-data`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExtractedDataResponseFromJSON(jsonValue));
    }

    /**
     * Get extracted data from document
     */
    async getDocumentExtractedData(requestParameters: GetDocumentExtractedDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExtractedDataResponse> {
        const response = await this.getDocumentExtractedDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all documents for the authenticated user\'s company
     */
    async getDocumentsRaw(requestParameters: GetDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['kind'] != null) {
            queryParameters['kind'] = requestParameters['kind'];
        }

        if (requestParameters['parseStatus'] != null) {
            queryParameters['parseStatus'] = requestParameters['parseStatus'];
        }

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * List all documents for the authenticated user\'s company
     */
    async getDocuments(requestParameters: GetDocumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentsResponse> {
        const response = await this.getDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get document extraction status
     */
    async getExtractionStatusRaw(requestParameters: GetExtractionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetExtractionStatus200Response>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getExtractionStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}/extraction-status`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetExtractionStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Get document extraction status
     */
    async getExtractionStatus(requestParameters: GetExtractionStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetExtractionStatus200Response> {
        const response = await this.getExtractionStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all documents uploaded by the authenticated user
     */
    async getUserDocumentsRaw(requestParameters: GetUserDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['kind'] != null) {
            queryParameters['kind'] = requestParameters['kind'];
        }

        if (requestParameters['parseStatus'] != null) {
            queryParameters['parseStatus'] = requestParameters['parseStatus'];
        }

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/my`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDocumentsResponseFromJSON(jsonValue));
    }

    /**
     * Get all documents uploaded by the authenticated user
     */
    async getUserDocuments(requestParameters: GetUserDocumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentsResponse> {
        const response = await this.getUserDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all document folder templates for the current company
     */
    async listDocumentFolderTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentFolderTemplatesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/document-folder-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDocumentFolderTemplatesResponseFromJSON(jsonValue));
    }

    /**
     * List all document folder templates for the current company
     */
    async listDocumentFolderTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentFolderTemplatesResponse> {
        const response = await this.listDocumentFolderTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * List all document folders for a claim
     */
    async listDocumentFoldersRaw(requestParameters: ListDocumentFoldersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocumentFoldersResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling listDocumentFolders().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/folders`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDocumentFoldersResponseFromJSON(jsonValue));
    }

    /**
     * List all document folders for a claim
     */
    async listDocumentFolders(requestParameters: ListDocumentFoldersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocumentFoldersResponse> {
        const response = await this.listDocumentFoldersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Move a document into a folder or back to root
     */
    async moveDocumentToFolderRaw(requestParameters: MoveDocumentToFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteChatConversation200Response>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling moveDocumentToFolder().'
            );
        }

        if (requestParameters['moveDocumentToFolderRequest'] == null) {
            throw new runtime.RequiredError(
                'moveDocumentToFolderRequest',
                'Required parameter "moveDocumentToFolderRequest" was null or undefined when calling moveDocumentToFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/folders/move-document`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: MoveDocumentToFolderRequestToJSON(requestParameters['moveDocumentToFolderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteChatConversation200ResponseFromJSON(jsonValue));
    }

    /**
     * Move a document into a folder or back to root
     */
    async moveDocumentToFolder(requestParameters: MoveDocumentToFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteChatConversation200Response> {
        const response = await this.moveDocumentToFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a document
     */
    async updateDocumentRaw(requestParameters: UpdateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling updateDocument().'
            );
        }

        if (requestParameters['updateDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDocumentRequest',
                'Required parameter "updateDocumentRequest" was null or undefined when calling updateDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDocumentRequestToJSON(requestParameters['updateDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Update a document
     */
    async updateDocument(requestParameters: UpdateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.updateDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a document folder (rename, move, recolor)
     */
    async updateDocumentFolderRaw(requestParameters: UpdateDocumentFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentFolder>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateDocumentFolder().'
            );
        }

        if (requestParameters['folderId'] == null) {
            throw new runtime.RequiredError(
                'folderId',
                'Required parameter "folderId" was null or undefined when calling updateDocumentFolder().'
            );
        }

        if (requestParameters['updateDocumentFolderRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDocumentFolderRequest',
                'Required parameter "updateDocumentFolderRequest" was null or undefined when calling updateDocumentFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/folders/{folderId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"folderId"}}`, encodeURIComponent(String(requestParameters['folderId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDocumentFolderRequestToJSON(requestParameters['updateDocumentFolderRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFolderFromJSON(jsonValue));
    }

    /**
     * Update a document folder (rename, move, recolor)
     */
    async updateDocumentFolder(requestParameters: UpdateDocumentFolderOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentFolder> {
        const response = await this.updateDocumentFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a document folder template
     */
    async updateDocumentFolderTemplateRaw(requestParameters: UpdateDocumentFolderTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentFolderTemplate>> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling updateDocumentFolderTemplate().'
            );
        }

        if (requestParameters['updateDocumentFolderTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateDocumentFolderTemplateRequest',
                'Required parameter "updateDocumentFolderTemplateRequest" was null or undefined when calling updateDocumentFolderTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/document-folder-templates/{templateId}`.replace(`{${"templateId"}}`, encodeURIComponent(String(requestParameters['templateId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateDocumentFolderTemplateRequestToJSON(requestParameters['updateDocumentFolderTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFolderTemplateFromJSON(jsonValue));
    }

    /**
     * Update a document folder template
     */
    async updateDocumentFolderTemplate(requestParameters: UpdateDocumentFolderTemplateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentFolderTemplate> {
        const response = await this.updateDocumentFolderTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update document parse status
     */
    async updateDocumentParseStatusRaw(requestParameters: UpdateDocumentParseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling updateDocumentParseStatus().'
            );
        }

        if (requestParameters['updateParseStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateParseStatusRequest',
                'Required parameter "updateParseStatusRequest" was null or undefined when calling updateDocumentParseStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/documents/{documentId}/parse-status`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateParseStatusRequestToJSON(requestParameters['updateParseStatusRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Update document parse status
     */
    async updateDocumentParseStatus(requestParameters: UpdateDocumentParseStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.updateDocumentParseStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetCompanyDocumentsKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type GetCompanyDocumentsKindEnum = typeof GetCompanyDocumentsKindEnum[keyof typeof GetCompanyDocumentsKindEnum];
/**
 * @export
 */
export const GetCompanyDocumentsParseStatusEnum = {
    Pending: 'pending',
    Parsed: 'parsed',
    Failed: 'failed'
} as const;
export type GetCompanyDocumentsParseStatusEnum = typeof GetCompanyDocumentsParseStatusEnum[keyof typeof GetCompanyDocumentsParseStatusEnum];
/**
 * @export
 */
export const GetCompanyDocumentsSortByEnum = {
    Filename: 'filename',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    SizeBytes: 'sizeBytes'
} as const;
export type GetCompanyDocumentsSortByEnum = typeof GetCompanyDocumentsSortByEnum[keyof typeof GetCompanyDocumentsSortByEnum];
/**
 * @export
 */
export const GetCompanyDocumentsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetCompanyDocumentsSortOrderEnum = typeof GetCompanyDocumentsSortOrderEnum[keyof typeof GetCompanyDocumentsSortOrderEnum];
/**
 * @export
 */
export const GetDocumentsKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type GetDocumentsKindEnum = typeof GetDocumentsKindEnum[keyof typeof GetDocumentsKindEnum];
/**
 * @export
 */
export const GetDocumentsParseStatusEnum = {
    Pending: 'pending',
    Parsed: 'parsed',
    Failed: 'failed'
} as const;
export type GetDocumentsParseStatusEnum = typeof GetDocumentsParseStatusEnum[keyof typeof GetDocumentsParseStatusEnum];
/**
 * @export
 */
export const GetDocumentsSortByEnum = {
    Filename: 'filename',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    SizeBytes: 'sizeBytes'
} as const;
export type GetDocumentsSortByEnum = typeof GetDocumentsSortByEnum[keyof typeof GetDocumentsSortByEnum];
/**
 * @export
 */
export const GetDocumentsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetDocumentsSortOrderEnum = typeof GetDocumentsSortOrderEnum[keyof typeof GetDocumentsSortOrderEnum];
/**
 * @export
 */
export const GetUserDocumentsKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type GetUserDocumentsKindEnum = typeof GetUserDocumentsKindEnum[keyof typeof GetUserDocumentsKindEnum];
/**
 * @export
 */
export const GetUserDocumentsParseStatusEnum = {
    Pending: 'pending',
    Parsed: 'parsed',
    Failed: 'failed'
} as const;
export type GetUserDocumentsParseStatusEnum = typeof GetUserDocumentsParseStatusEnum[keyof typeof GetUserDocumentsParseStatusEnum];
/**
 * @export
 */
export const GetUserDocumentsSortByEnum = {
    Filename: 'filename',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    SizeBytes: 'sizeBytes'
} as const;
export type GetUserDocumentsSortByEnum = typeof GetUserDocumentsSortByEnum[keyof typeof GetUserDocumentsSortByEnum];
/**
 * @export
 */
export const GetUserDocumentsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetUserDocumentsSortOrderEnum = typeof GetUserDocumentsSortOrderEnum[keyof typeof GetUserDocumentsSortOrderEnum];
